import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Home } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: attempted non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-md">
        <div className="rounded-md border border-border bg-card p-6">
          <p className="label-meta">Error 404</p>
          <h1 className="mt-2 text-[19px] font-semibold tracking-[-0.015em] text-foreground">
            That route does not exist
          </h1>
          <p className="mt-1 text-[13px] leading-5 text-muted-foreground">
            The console has eighteen routes and this is not one of them. The address may have been
            mistyped or the page may have been removed.
          </p>
          <code className="mt-3 block truncate rounded-sm bg-muted/60 px-2 py-1 font-mono text-[11px] text-muted-foreground">
            {location.pathname}
          </code>
          <div className="mt-5 flex flex-wrap items-center gap-2">
            <Button variant="outline" size="sm" onClick={() => navigate(-1)} className="h-8 gap-1.5 text-[12px]">
              <ArrowLeft className="h-3.5 w-3.5" />
              Go back
            </Button>
            <Button size="sm" onClick={() => navigate("/")} className="h-8 gap-1.5 text-[12px]">
              <Home className="h-3.5 w-3.5" />
              Dashboard
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
